import { resources } from "@constants/hardcoded-strings";
import styles from "./properties-section-description.less";

type PropertiesSectionDescriptionProps = {
    description: string;
    documentationLink?: string;
};

export const PropertiesSectionDescription = (props: PropertiesSectionDescriptionProps) => {
    const { description, documentationLink } = props;

    return (
        <div className={styles.propertiesSectionDescription}>
            <span>{description}</span>
            {documentationLink && (
                <a href={documentationLink} target={"_blank"} rel="noreferrer">{resources.common.documentation}</a>
            )}
        </div>
    );
};